// extracted by mini-css-extract-plugin
export default {"row":"kMbsAeNmfQ7hBod68mTa","title":"jzDvxynwdiIvScBVHAwG"};